import React, {Component} from 'react';


class StandingsAppDesktop extends Component {
  render(){
    return(
        <div className="standings-app-container">
        <div className="generic-standings-table standings-app-main-standings">
        <div className="standings-table-header left ">Greece : Super League<span className="standings-table-header-subtitle">STANDINGS TABLE</span><div className="standings-table-header-arrow" aria-hidden="true"></div></div>
        <table>
           <thead>
              <tr className="header-row">
                 <th colSpan="4" className="generic-standings-table-header-cell border"></th>
                 <th colSpan="6" className="generic-standings-table-header-cell border">TOTAL</th>
                 <th colSpan="4" className="generic-standings-table-header-cell border">HOME</th>
                 <th colSpan="4" className="generic-standings-table-header-cell border">AWAY</th>
              </tr>
              <tr className="header-row">
                 <th className="generic-standings-table-header-cell border">#</th>
                 <th className="generic-standings-table-header-cell border"></th>
                 <th className="generic-standings-table-header-cell border">TEAM</th>
                 <th className="generic-standings-table-header-cell border">PTS</th>
                 <th className="generic-standings-table-header-cell border">MP</th>
                 <th className="generic-standings-table-header-cell border">W</th>
                 <th className="generic-standings-table-header-cell border">D</th>
                 <th className="generic-standings-table-header-cell border">L</th>
                 <th className="generic-standings-table-header-cell border">G</th>
                 <th className="generic-standings-table-header-cell border">GD</th>
                 <th className="generic-standings-table-header-cell border">W</th>
                 <th className="generic-standings-table-header-cell border">D</th>
                 <th className="generic-standings-table-header-cell border">L</th>
                 <th className="generic-standings-table-header-cell border">G</th>
                 <th className="generic-standings-table-header-cell border">W</th>
                 <th className="generic-standings-table-header-cell border">D</th>
                 <th className="generic-standings-table-header-cell border">L</th>
                 <th className="generic-standings-table-header-cell border">G</th>
              </tr>
           </thead>
           <tbody className="">
              <tr>
                 <td className="generic-standings-table-body-cell border legend-1">1</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/3300.png" alt="OLYMPIAKOS"/></td>
                 <td className="generic-standings-table-body-cell border">OLYMPIAKOS</td>
                 <td className="generic-standings-table-body-cell border">32</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">10</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">32:16</td>
                 <td className="generic-standings-table-body-cell border">16</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">17:6</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">15:10</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border legend-11">2</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/3307.png" alt="AEK ATHENS"/></td>
                 <td className="generic-standings-table-body-cell border">AEK ATHENS</td>
                 <td className="generic-standings-table-body-cell border">31</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">9</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">22:8</td>
                 <td className="generic-standings-table-body-cell border">14</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">16:4</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">6:4</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border legend-11">3</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/3258.png" alt="PAOK THESSALONIKI FC"/></td>
                 <td className="generic-standings-table-body-cell border">PAOK THESSALONIKI FC</td>
                 <td className="generic-standings-table-body-cell border">31</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">9</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">24:7</td>
                 <td className="generic-standings-table-body-cell border">17</td>
                 <td className="generic-standings-table-body-cell border">7</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">17:2</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">7:5</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border legend-11">4</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/180.png" alt="ATROMITOS"/></td>
                 <td className="generic-standings-table-body-cell border">ATROMITOS</td>
                 <td className="generic-standings-table-body-cell border">30</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">8</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">20:8</td>
                 <td className="generic-standings-table-body-cell border">12</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">7:2</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">13:6</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border legend-11">5</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/3418.png" alt="PANIONIOS"/></td>
                 <td className="generic-standings-table-body-cell border">PANIONIOS</td>
                 <td className="generic-standings-table-body-cell border">22</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">19:16</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">14:10</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">5:6</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/880.png" alt="ASTERAS TRIPOLIS"/></td>
                 <td className="generic-standings-table-body-cell border">ASTERAS TRIPOLIS</td>
                 <td className="generic-standings-table-body-cell border">22</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">19:12</td>
                 <td className="generic-standings-table-body-cell border">7</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">11:6</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">8:6</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">7</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/183.png" alt="LARISA"/></td>
                 <td className="generic-standings-table-body-cell border">LARISA</td>
                 <td className="generic-standings-table-body-cell border">20</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">14:21</td>
                 <td className="generic-standings-table-body-cell border">-7</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">6:3</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">8:18</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">8</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/168.png" alt="LEVADIAKOS"/></td>
                 <td className="generic-standings-table-body-cell border">LEVADIAKOS</td>
                 <td className="generic-standings-table-body-cell border">18</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">10:13</td>
                 <td className="generic-standings-table-body-cell border">-3</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">7:6</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">3:7</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">9</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/3299.png" alt="XANTHI"/></td>
                 <td className="generic-standings-table-body-cell border">XANTHI</td>
                 <td className="generic-standings-table-body-cell border">18</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">13:14</td>
                 <td className="generic-standings-table-body-cell border">-1</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">5:8</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">8:6</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">10</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/181.png" alt="PAS GIANNINA"/></td>
                 <td className="generic-standings-table-body-cell border">PAS GIANNINA</td>
                 <td className="generic-standings-table-body-cell border">17</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">8</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">16:17</td>
                 <td className="generic-standings-table-body-cell border">-1</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">9:6</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">7:11</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">11</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/3752.png" alt="PANATHINAIKOS"/></td>
                 <td className="generic-standings-table-body-cell border">PANATHINAIKOS<i className="generic-standings-table-asterisk"> *</i></td>
                 <td className="generic-standings-table-body-cell border">16</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">11:15</td>
                 <td className="generic-standings-table-body-cell border">-4</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">7:3</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">4:12</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">12</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/1254.png" alt="LAMIA"/></td>
                 <td className="generic-standings-table-body-cell border">LAMIA</td>
                 <td className="generic-standings-table-body-cell border">16</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">7</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">12:18</td>
                 <td className="generic-standings-table-body-cell border">-6</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">7:8</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">5:10</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">13</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/1267.png" alt="PANAITOLIKOS"/></td>
                 <td className="generic-standings-table-body-cell border">PANAITOLIKOS</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">17:20</td>
                 <td className="generic-standings-table-body-cell border">-3</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">10:12</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">7:8</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border">14</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/1270.png" alt="APOLLON SMIRNIS"/></td>
                 <td className="generic-standings-table-body-cell border">APOLLON SMIRNIS</td>
                 <td className="generic-standings-table-body-cell border">12</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">7</td>
                 <td className="generic-standings-table-body-cell border">12:19</td>
                 <td className="generic-standings-table-body-cell border">-7</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">8:8</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">4:11</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border legend-6">15</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/128.png" alt="KERKYRA"/></td>
                 <td className="generic-standings-table-body-cell border">KERKYRA</td>
                 <td className="generic-standings-table-body-cell border">11</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">8</td>
                 <td className="generic-standings-table-body-cell border">10:24</td>
                 <td className="generic-standings-table-body-cell border">-14</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">6:11</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">4</td>
                 <td className="generic-standings-table-body-cell border">4:13</td>
              </tr>
              <tr>
                 <td className="generic-standings-table-body-cell border legend-6">16</td>
                 <td className="generic-standings-table-body-cell border"><img className="generic-standings-table-image" src="https://www.europaleague.gr/betarades/cdn/teams/8784.png" alt="PLATANIAS"/></td>
                 <td className="generic-standings-table-body-cell border">PLATANIAS</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">15</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">3</td>
                 <td className="generic-standings-table-body-cell border">11</td>
                 <td className="generic-standings-table-body-cell border">7:30</td>
                 <td className="generic-standings-table-body-cell border">-23</td>
                 <td className="generic-standings-table-body-cell border">0</td>
                 <td className="generic-standings-table-body-cell border">2</td>
                 <td className="generic-standings-table-body-cell border">6</td>
                 <td className="generic-standings-table-body-cell border">2:14</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">1</td>
                 <td className="generic-standings-table-body-cell border">5</td>
                 <td className="generic-standings-table-body-cell border">5:16</td>
              </tr>
           </tbody>
        </table>
        <div className="generic-standings-table-footer">
           <div className="generic-standings-table-footer-container">
              <div className="generic-standings-table-legend-container">
                 <div><span className="generic-standings-table-footer-color legend-1"></span><span className="generic-standings-table-footer-title">Champions League</span></div>
                 <div><span className="generic-standings-table-footer-color legend-11"></span><span className="generic-standings-table-footer-title">Playoff</span></div>
                 <div><span className="generic-standings-table-footer-color legend-6"></span><span className="generic-standings-table-footer-title">Relegation</span></div>
              </div>
              <div className="generic-standings-table-penalty-container">
                 <div>
                    <div className="generic-standings-table-penalty-title">(*) Standings Corrections</div>
                    <span className="generic-standings-table-penalty-value">PANATHINAIKOS: -2</span>
                 </div>
              </div>
           </div>
        </div>
     </div>
     </div>
    );
  }
}



export default StandingsAppDesktop;



// WEBPACK FOOTER //
// ./src/components/samples/standingsAppDesktop.js